export const NEW_ADMIN_BOOK = () => {
  return {
    createdAt: new Date(),
    modifiedAt: new Date(),
    tags: [],
    isDeleted: false,
    isPublic: true,
  }
};